import { COMPONENT_NAMES } from "../../app-designer/utils/configuration/componentName.contants";

export const COMPONENT_ARGS = {
    [COMPONENT_NAMES.STEPPER]: 'e,oldStepIndex,newStepIndex',
    [COMPONENT_NAMES.DATAGRID]: 'column,order,text,row,e,obj,index,rows',
    [COMPONENT_NAMES.DATAGRID_CELL]: 'column,row',
    DEFAULT: 'e,obj,index'
}